export default __webpack_public_path__ + "static/media/Logo-Leader-Park-Square.638f5eac.png";